import React, { PropsWithChildren, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";

const images = [
  {
    id: 1,
    img: "/images/banners/banner_1.jpg",
  },
  {
    id: 2,
    img: "/images/banners/banner_2.jpg",
  },
  {
    id: 3,
    img: "/images/banners/banner_3.jpg",
  },
  {
    id: 4,
    img: "/images/banners/banner_4.jpg",
  },
];

export default function LoginLayout({ children }: PropsWithChildren) {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveImage((prev) => (prev + 1) % images.length);
    }, 3500);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <Box minHeight="100vh" width="100%" bgcolor="#f7fbff">
      <Grid
        container
        minHeight="100vh"
        alignItems="center"
      >
        <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            px={{ xs: 2.5, sm: 4, md: 6 }}
            py={{ xs: 4, md: 3 }}
            maxWidth={640}
            mx="auto"
          >
            <Box
              display="flex"
              mt={2}
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <img
                src="/images/icons/sammitra_logo.png"
                alt="Sammitra logo"
                height={150}
                width={150}
              />
            </Box>
            <Box
              display="flex"
              mt={2}
              mb={2}
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Typography
                variant="body1"
                color="#637381"
                textAlign="center"
              >
                SAMMITRA, Youth Commission - Diocese of Udupi
              </Typography>
            </Box>

            {children}
          </Box>
        </Grid>

        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Box
            px={{ xs: 2, sm: 3, md: 4 }}
            pt={{ xs: 2, md: 0 }}
            pb={{ xs: 0, md: 0 }}
          >
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: { xs: 3, md: 5 },
                height: { xs: 260, sm: 340, md: "88vh" },
                minHeight: { md: 560 },
                boxShadow: "0 20px 48px rgba(13, 56, 91, 0.18)",
              }}
            >
              {images.map((image, index) => (
                <Box
                  key={image.id}
                  sx={{
                    position: "absolute",
                    inset: 0,
                    opacity: activeImage === index ? 1 : 0,
                    transition: "opacity 900ms ease",
                  }}
                >
                  <Box
                    component="img"
                    src={image.img}
                    alt={`Login banner ${index + 1}`}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              ))}

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(8, 48, 79, 0.08) 0%, rgba(8, 48, 79, 0.36) 100%)",
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 18,
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                {images.map((image, index) => (
                  <Box
                    key={image.id}
                    sx={{
                      width: activeImage === index ? 26 : 10,
                      height: 10,
                      borderRadius: 999,
                      transition: "all 300ms ease",
                      bgcolor:
                        activeImage === index
                          ? "#ffffff"
                          : "rgba(255,255,255,0.55)",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
